<template>
    <div class="c-layoutLoading">
        <span class="c-layoutLoading__loading">
            <span class="c-layoutLoading__loadingDot"/>
            <span class="c-layoutLoading__loadingDot"/>
            <span class="c-layoutLoading__loadingDot"/>
        </span>
    </div>
</template>

<style lang="scss">
@import '~@karriereat/global-styles/scss/components/loading-dots/mixins';

.c-layoutLoading {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    height: 100vh; // fallback, svh not supported everywhere
    height: 100svh;

    &__loading {
        @include k-c-loadingDots($k-spacing--m, 'Dot');
    }
}
</style>
